module.exports = __webpack_public_path__ + "static/media/realtime-bold.66302308.woff";